export const QA_NAME_CALENDAR_RELIEVE_DAY_FOLLOW_UP =
  'calendarRelieveDayFollowUp'
